import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  QueryList,
  TemplateRef,
  ViewChild,
  ViewChildren,
  ViewContainerRef,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { v4 as uuidv4 } from 'uuid';
import { isLargeScreen } from '../../../../../../global.variable';
import { AppService } from '../../../../../app.service';
import { UserProfileService } from '../../../../../profile/user-profile/user-profile.service';
import { ConfirmDialogComponent } from '../../../../../shared/components/confirm-dialog/confirm-dialog.component';
import { FileUploadComponent } from '../../../../../shared/components/file-upload/file-upload.component';
import { MediaPreviewComponent } from '../../../../../shared/components/media-preview/media-preview.component';
import { ModalDialogueService } from '../../../../../shared/components/modal-dialogue/modal-dialogue.service';
import { ViewUserDetailComponent } from '../../../../../shared/components/view-user-detail/view-user-detail.component';
import { DataCheckService } from '../../../../../shared/services/data-check.service';
import { gTDB } from '../../../../../shared/services/db';
import { DeviceInfoService } from '../../../../../shared/services/device-info.service';
import { LoadingSpinnerService } from '../../../../../shared/services/loading-spinner.service';
import { ToasterService } from '../../../../../shared/services/toaster.service';
import { WebSocketService } from '../../../../../shared/services/web-socket.service';
import { PagesService } from '../../../pages.service';
import { UsersService } from '../../../users/users.service';
import { HolAndMessageService } from '../../hol-and-message.service';
@Component({
  selector: 'gtapp-message',
  templateUrl: './message.component.html',
  styleUrl: './message.component.scss',
  standalone: false,
})
export class MessageComponent implements OnInit, AfterViewInit, OnDestroy {
  largeView: Boolean = isLargeScreen;
  conversationListData: any = [];
  conversationDetailedDataDict: any = {};
  userConvDetailedDataDict: any = {};

  hasArchivedChats: boolean = false;
  showArchivedList: boolean = false;

  unreadArchivedConversationCount: number = 0;

  assigneeSearchList: any = [];
  assigneeList: any = [];

  chatFilterValue: string = '';
  chatSearchLookup: boolean = false;
  filteredChatListData: any = [];
  onChatSearchLookupTimeOutFn: any;

  subscriberUserId =
    this.appService.getUserData()?.subscriber?.subscriber_user_id;

  pageSize = this.largeView ? 20 : 10; // keep the initial value small to reduce the scroll to bottom

  rows: number = this.pageSize;

  chatFirstLastIds: any = {}; // this will contain the first and last id of the conversation which will be used for pagination check instead of total rows

  selectedChatConversation: any;
  messageList: any = [];
  sendBtnPressed: boolean = false;
  chatMessage: string = '';

  containerHeight: string = `${
    Math.max(document.documentElement.clientHeight, window.innerHeight) -
    Math.max(this.largeView ? 70 : 60, 0)
  }px`;

  @ViewChild('content') content: any = ElementRef;
  @ViewChildren('anchor') anchorList: QueryList<ElementRef> | any;
  anchorIndex: number = 0;
  scrollTimeout: any;
  handOverLogData: any;

  showFabActions: boolean = false;

  selectedMessage: any;
  filteredJobList: any = [];
  jobFilterValue: any;
  selectedJob: any;
  webSocketSubscription: any;
  websocketMessageReceivedCount = 0;

  today = new Date();

  selectedMessageIndex: any;

  forwardMessageUserListData: any = [];
  selectedForwardMessageUsers: any = [];

  isAdmin = this.dataCheckService.isUserAdmin();
  isDispatchUser = this.dataCheckService.isDispatchUser();

  groupMemberColorAssign: any = {};
  loggedInDeviceID: string = this.deviceInfoService.getUniqueDeviceID();

  selectedGroupDetails: any = {};
  selectedGroupDetailsBackup: any = {};

  selectedGroupMembers: any = [];

  hasGroupAdminPrivilage: boolean = false;
  isGroupOwner: boolean = false;
  openNewlyAddedGroup: boolean = false;

  dialogRef: any;
  initialLoadComplete: boolean = false; // this value is to prevent the window scroll ie triggered when the page loads which is just calling the messages api and changing the list

  showChatOptions: boolean = false;

  offlineMode = !navigator.onLine;
  deviceInfoSubscription: any;
  pageMiscParamSubscription: any;
  messagesListForOfflineSearch: any = [];

  addGroupOptionAvailable: boolean = false;

  messageChannel = new MessageChannel();
  userDetailPopoverTemplate = ViewUserDetailComponent;

  gtNotificationCount: number = 1;
  gtNotificationsList: any = [];
  gtNotificationCursor: string = '';

  // https://app.shortcut.com/sendem/story/11929/messaging-live-drafting
  liveDraftingTimeOutFn: any;
  liveDraftInfoSend: boolean = false;
  isInLiveDraft: boolean = false;
  liveDraftBy: any = {};

  constructor(
    private messageService: HolAndMessageService,
    private toasterService: ToasterService,
    private appService: AppService,
    private dialogService: ModalDialogueService,
    private viewContainerRef: ViewContainerRef,
    private router: Router,
    private spinnerService: LoadingSpinnerService,
    private route: ActivatedRoute,
    private webSocketService: WebSocketService,
    private userService: UsersService,
    private dataCheckService: DataCheckService,
    private deviceInfoService: DeviceInfoService,
    private pageService: PagesService,
    private cdr: ChangeDetectorRef,
    private profileService: UserProfileService,
  ) {
    this.pageService.miscSubjectParam.next({
      isOnEvent: true,
    });
    this.pageMiscParamSubscription =
      this.pageService.miscSubjectParam.subscribe((value: any) => {
        if (value?.preProcess) {
          this.formatSendMessageApiResponse({ data: value?.response });
        }
        if (value?.afterResponse) {
          this.getAndFormatCachedMessages();

          if (value?.response?.data?.id) {
            this.formatSendMessageApiResponse(value?.response);
          }
        }
      });
    this.deviceInfoSubscription =
      this.deviceInfoService.deviceInfoSubject.subscribe((value: any) => {
        if ('appStatus' in value) {
          this.pageService.miscSubjectParam.next({
            isOnEvent: true,
          });
          if (this.offlineMode && value?.appStatus) {
            // app went online from offline
            this.getGroupORUserMessageList();
            if (this.selectedChatConversation?.id) {
              const selectedConv = this.selectedChatConversation;
              this.selectedChatConversation = null;
              this.getConversationMessagesList(selectedConv);
            }
          } else if (!this.offlineMode && !value?.appStatus) {
            if (this.selectedChatConversation?.id)
              this.backupMessagesToIndexDb(
                this.selectedChatConversation,
                this.messageList,
              );
            // app went offline  from online

            setTimeout(() => {
              this.getMessagesAndInfoFromIndexDb({});
            }, 1000);
          }
          this.chatFilterValue = '';
          this.offlineMode = !value?.appStatus;
        }
      });

    this.getDeviceID();
    let reqDict: any = {};
    const groupORUserId: any = this.route.snapshot.fragment;
    if (groupORUserId) {
      const split = groupORUserId?.split(':');

      reqDict = {
        id: split[0],
      };

      if (split?.length > 1) {
        reqDict['chat_type'] = 'group_chat';
      }
    }
    if (this.offlineMode) {
      this.getMessagesAndInfoFromIndexDb(reqDict);
    } else {
      if (reqDict?.id) this.getConversationMessagesList(reqDict);
      this.getGroupORUserMessageList();
    }

    this.webSocketSubscription =
      this.webSocketService.webSocketSubject.subscribe((event: any) => {
        if (this.loggedInDeviceID == event?.logged_in_device_id) {
          return;
        }

        if (
          [
            'wsn_user_clock_in',
            'wsn_user_clock_out',
            'wsn_group_chat',
            'wsn_delete_group_chat',
          ].includes(event?.event)
        ) {
          this.getGroupORUserMessageList();
        }
        if (
          [
            'wsn_live_draft_end_response',
            'wsn_live_draft_start_response',
          ].includes(event?.event) &&
          event?.data?.conversation_id == this.selectedChatConversation?.id
        ) {
          this.isInLiveDraft =
            event?.event === 'wsn_live_draft_start_response' ? true : false;
          this.liveDraftBy = this.conversationListData?.find(
            (user: any) => user?.id == event?.data?.sender_id,
          );
        }

        if (event?.event === 'wsn_individual_chat' && event?.data?.id) {
          if (this.selectedChatConversation?.id) {
            if (this.isLastItemVisible()) {
              // user is at the bottom of the screen
              this.appendNewMessage(event?.data);
              this.websocketMessageReceivedCount = 0;
              this.scrollToBottom();
            } else {
              this.appendNewMessage(event?.data);
            }
          }

          const index = this.conversationListData?.findIndex(
            (item: any) =>
              item?.id == (event?.data?.group_id || event?.data?.sender?.id),
          );

          if (index !== -1) {
            const updateConv = this.conversationListData[index];
            let updateDict: any = {
              ...updateConv,
              last_message: this.getLastMessageInfo(event?.data),
              sent_at: event?.data?.created_at,
              last_seen: event?.data?.group_id ? null : event?.data?.created_at,
              sent_by: event?.data?.sender?.user_name?.split(' ')[0],
            };
            if (updateConv?.id !== this.selectedChatConversation?.id) {
              updateDict.unread_count = (updateConv?.unread_count || 0) + 1;
            }
            this.conversationListData[index] = updateDict;

            if (updateConv?.chat_type == 'group_chat') {
              // update last seen for the sender also
              const senderConvIndex = this.conversationListData?.findIndex(
                (item: any) => item?.id == event?.data?.sender?.id,
              );
              if (senderConvIndex !== -1) {
                this.conversationListData[senderConvIndex] = {
                  ...this.conversationListData[senderConvIndex],
                  last_seen: event?.data?.created_at,
                };
              }
            }
          }

          this.sortUserList();
        } else if (event?.event === 'wsn_chat_delete' && event?.data?.id) {
          const msgId = event?.data?.id;
          this.messageList = this.messageList?.filter(
            (msg: any) => msg?.id != msgId,
          );

          this.updateChatFirstLastIds();
        } else if (
          event?.event == 'update_read_messages' &&
          event?.data?.length
        ) {
          const map = new Map<number, any>();
          let lastSeenDict: any = {};
          for (const item of event?.data) {
            map.set(item.id, item);
            this.updateLastSeenFromReadMessages(item, lastSeenDict);
          }
          if (Object.keys(lastSeenDict)?.length) {
            this.conversationListData?.forEach((user: any) => {
              const lastSeenAt = lastSeenDict?.[user?.id];
              if (
                lastSeenAt &&
                new Date(lastSeenAt)?.getTime() >
                  new Date(user?.last_seen)?.getTime()
              ) {
                user.last_seen = new Date(lastSeenAt)?.getTime();
                if (user?.id === this.selectedChatConversation?.id) {
                  this.selectedChatConversation.last_seen = new Date(
                    lastSeenAt,
                  )?.getTime();
                }
              }
            });
          }

          this.messageList = this.messageList?.map(
            (item: any) => map.get(item.id) || item,
          );
        }
      });

    document.addEventListener('visibilitychange', this.handleVisibilityChange);
  }
  closeOpenedItemsOutsideClick() {
    this.selectedMessageIndex = null;
    this.showChatOptions = false;
  }
  handleVisibilityChange = () => {
    if (document.hidden) {
      this.updateUserPostion();
    } else {
      this.getGroupORUserMessageList();
      if (this.selectedChatConversation?.id) {
        const selectedChat = this.selectedChatConversation;
        this.selectedChatConversation = null;
        this.resetPagesAndGetData(selectedChat);
      }
    }
  };
  updateLastSeenFromReadMessages(msgData: any, lastSeenDict: any) {
    try {
      const senderId = msgData?.sender?.id;
      const createdAt = msgData?.created_at;

      if (!lastSeenDict[senderId]) {
        lastSeenDict[senderId] = createdAt;
      } else if (
        new Date(createdAt)?.getTime() >
        new Date(lastSeenDict[senderId])?.getTime()
      ) {
        lastSeenDict[senderId] = createdAt;
      }

      // Safely handle read_json
      const readJson = msgData.read_json ?? {};

      for (const userId of Object.keys(readJson)) {
        const readTime = readJson[userId];
        const existing = lastSeenDict[userId];
        if (!existing) {
          lastSeenDict[userId] = readTime;
        } else if (
          new Date(readTime)?.getTime() > new Date(existing)?.getTime()
        ) {
          lastSeenDict[userId] = readTime;
        }
      }
    } catch (error) {}
  }
  appendNewMessage(msg: any) {
    const checkId = msg?.group_id || msg?.sender?.id;

    if (msg?.sender?.id == this.subscriberUserId) {
      // for updating processing audio for senders
      const index = this.messageList?.findIndex(
        (item: any) => item?.id == msg?.id,
      );

      if (index !== -1) {
        // Replace the existing dictionary
        this.messageList[index] = { ...this.messageList[index], ...msg };
      }
    }

    if (this.selectedChatConversation?.id === checkId) {
      const index = this.messageList?.findIndex(
        (item: any) => item?.id == msg?.id,
      );
      if (this.selectedChatConversation?.chat_type != 'group_chat') {
        this.selectedChatConversation.last_seen = new Date();
      }
      if (index !== -1) {
        // Replace the existing dictionary
        this.messageList[index] = { ...msg };
      } else {
        this.messageList?.push(msg);
        this.updateChatFirstLastIds();

        this.websocketMessageReceivedCount += 1;
      }
      this.markMessagesRead();
    }
  }
  getDeviceID() {
    if (!this.loggedInDeviceID) {
      this.loggedInDeviceID = this.deviceInfoService.getUniqueDeviceID();
    }
  }

  ngOnDestroy(): void {
    this.sendLiveDraftStartEnd('wsn_live_draft_end');
    if (this.webSocketSubscription) this.webSocketSubscription?.unsubscribe();
    if (this.deviceInfoSubscription) this.deviceInfoSubscription?.unsubscribe();
    if (this.pageMiscParamSubscription)
      this.pageMiscParamSubscription?.unsubscribe();
    document.removeEventListener(
      'visibilitychange',
      this.handleVisibilityChange,
    );
    this.backupMessagesToIndexDb(
      this.selectedChatConversation,
      this.messageList,
    );
    this.updateUserPostion();
  }
  isLastItemVisible() {
    const tolerance = 10;
    const lastItemElement = document.getElementById('lastItem');
    const contentElement = this.content.nativeElement;

    if (!lastItemElement || !contentElement) {
      return false;
    }

    const lastItemRect = lastItemElement.getBoundingClientRect();
    const contentRect = contentElement.getBoundingClientRect();

    const isVisible =
      lastItemRect.top >= contentRect.top - tolerance &&
      lastItemRect.bottom <= contentRect.bottom + tolerance;

    return isVisible;
  }

  ngOnInit(): void {
    this.handOverLogData = JSON.parse(
      sessionStorage.getItem('commentOnHOLData') || '{}',
    );
    sessionStorage.removeItem('commentOnHOLData');
    this.getDataFromSW();

    this.getNotificationTotalCount();
  }
  getDataFromSW() {
    navigator?.serviceWorker?.controller?.postMessage(
      {
        type: 'INIT_CHAT_MESSAGE_PORT',
      },
      [this.messageChannel.port2],
    );

    this.messageChannel.port1.onmessage = (event) => {
      if (event?.data?.data?.id) {
        this.formatSendMessageApiResponse(event?.data);
      }
    };
  }
  ngAfterViewInit(): void {
    navigator?.serviceWorker?.controller?.postMessage({
      type: 'clearNotifications',
    });

    setTimeout(() => {
      this.checkAndSetChatWindowHeight();
    }, 500);
  }

  scrollToBottom = (scrollToChatContainer = false) => {
    try {
      setTimeout(() => {
        const isLastItemVisible = this.isLastItemVisible();

        const lastItemElement: any = document.getElementById('lastItem');

        if (lastItemElement && !isLastItemVisible) {
          lastItemElement.scrollIntoView({
            behavior: 'smooth',
            block: 'end',
            inline: 'nearest',
          });
        }
        if (scrollToChatContainer || (lastItemElement && !isLastItemVisible)) {
          // iphone issue
          setTimeout(() => {
            const chatBottom: any = document.getElementById('chatBottom');
            if (chatBottom)
              chatBottom.scrollIntoView({
                behavior: 'smooth',
                block: 'start',
                inline: 'nearest',
              });
          }, 50);
        }
      }, 250);
    } catch (err) {}
  };

  onChatMessageClick(elementId: string, index: number): void {
    this.showChatOptions = false;
    if (!this.offlineMode) this.selectedMessageIndex = index;
    // to make sure the item is visible even after clicking and showing message options
    if (elementId) {
      this.scrollToBottom();
    }
  }

  markMessagesRead() {
    const isSuperUserAccess =
      localStorage.getItem(btoa('superUserAccess')) === 'true';
    if (isSuperUserAccess) return;
    const idList = [
      ...new Set(
        this.messageList
          ?.filter(
            (msg: any) =>
              !msg?.read_json?.[this.subscriberUserId] &&
              this.selectedChatConversation?.id ===
                (msg?.group_id || msg?.sender?.id),
          )
          ?.map((msg: any) => msg?.id),
      ),
    ];

    if (idList?.length) {
      const readMessageData = {
        event: 'read_messages',
        idList: idList,
        receiver_id: this.subscriberUserId,
      };

      this.webSocketService.sendData(readMessageData);
    }
  }
  getGroupORUserMessageList() {
    this.hasArchivedChats = false;
    this.showArchivedList = false;
    this.messageService
      .getConversationMessages({ list_users_and_groups: 1 })
      .subscribe((response: any) => {
        if (response?.status == 'success') {
          this.conversationListData = response?.data;
          this.hasArchivedChats = response?.archived_chats || false;

          this.getUserDetailedInfoForList();
        }
      });
  }
  getUserDetailedInfoForList() {
    this.messageService
      .getConversationMessages({ get_conversation_brief: 1, user_info: 1 })
      .subscribe((response: any) => {
        if (response?.status == 'success') {
          const conversationInfo = response?.data?.conversation_info;
          const userInfo = response?.data?.user_info;
          let selectedUserInfo: any = {};

          let counter = 0;

          this.conversationListData = this.conversationListData?.map(
            (conversation: any) => {
              const briefData =
                conversationInfo?.[conversation?.unique_conversation_id] || {};
              const userAddData = userInfo?.[conversation?.id] || {};
              const updatedDict = {
                ...conversation,
                ...briefData,
                ...userAddData,
              };
              if (conversation?.id === this.selectedChatConversation?.id) {
                selectedUserInfo = { ...selectedUserInfo, ...updatedDict };
              }
              if (conversation?.chat_type !== 'group_chat') counter += 1;
              return updatedDict;
            },
          );

          this.addGroupOptionAvailable = counter > 1;

          this.selectedChatConversation = {
            ...this.selectedChatConversation,
            ...selectedUserInfo,
          };
          this.sortUserList();
        }
      });
  }

  async formatGroupInfo(groupId: any) {
    this.hasGroupAdminPrivilage = false;
    this.isGroupOwner = false;
    this.assigneeList?.splice(0, 0, {
      id: this.subscriberUserId,
      user_name: 'You',
    });
    const grpDetails: any = await this.getGroupDetails(groupId);

    this.selectedGroupDetails = { ...grpDetails };
    this.selectedGroupDetailsBackup = { ...grpDetails };

    if (grpDetails?.id == this.selectedChatConversation?.id) {
      this.updateGroupMemberInfo(
        Object.keys(grpDetails?.member_additional_info),
      );
    }

    this.assigneeList = this.assigneeList?.map((user: any) => {
      const userAddData = grpDetails?.member_additional_info?.[user?.id] || {};
      const updatedDict = { ...user, ...userAddData };

      if (user?.id in grpDetails?.member_additional_info)
        updatedDict.selected = true;

      if (user?.id === this.subscriberUserId) {
        this.hasGroupAdminPrivilage =
          updatedDict?.additional_info?.is_group_admin;
        this.isGroupOwner = updatedDict?.additional_info?.is_group_owner;
      }

      return updatedDict;
    });
    const selectedMembers = this.assigneeList?.filter(
      (user: any) => user?.selected,
    );
    this.selectedGroupMembers = selectedMembers?.map((user: any) => {
      return {
        id: user?.id,
        additional_info: user?.additional_info,
      };
    });
  }

  async openTemplate(template: TemplateRef<any>, action = 'guard', data?: any) {
    let modifiedData: any = {};
    if (action == 'forwardComment') {
      modifiedData = { ...data };
      this.forwardMessageUserListData = JSON.parse(
        JSON.stringify(this.conversationListData),
      );
      this.forwardMessageUserListData = this.forwardMessageUserListData?.filter(
        (user: any) => user?.id !== this.selectedChatConversation?.id,
      );
    }
    if (action == 'editComment') {
      modifiedData = { ...data, oldValue: data?.message };
    }
    if (action == 'modifyGroup') {
      this.selectedGroupDetails = {};
      this.assigneeList = JSON.parse(
        JSON.stringify(
          this.conversationListData?.filter(
            (user: any) => user?.chat_type == 'individual_chat',
          ),
        ),
      );

      if (data?.id) {
        this.formatGroupInfo(data?.id);
      } else {
        modifiedData = {};

        this.assigneeList?.splice(0, 0, {
          id: this.subscriberUserId,
          user_name: 'You',
          additional_info: { is_group_owner: true, is_group_admin: true },
          selected: true,
        });
      }
    }

    this.dialogRef = this.dialogService.open(
      template,
      {
        data: modifiedData,
      },
      this.viewContainerRef,
    );
  }

  resetPagesAndGetData(groupORUserData: any) {
    this.isInLiveDraft = false;
    if (this.offlineMode) {
      const selectedUser = this.conversationListData?.find(
        (chat: any) => chat?.id == groupORUserData?.id,
      );

      if (selectedUser?.id && selectedUser?.chatListData?.length) {
        this.selectedChatConversation = selectedUser;
        this.messageList = selectedUser?.chatListData;
        if (groupORUserData?.message_id) {
          this.highlightSelectedMessageFromChat(groupORUserData?.message_id);
        }

        this.resetChanges();
      } else {
        this.toasterService.setMessage({
          successMessage: '',
          errorMessage:
            'No data found. Please make sure you have internet connection',
        });
      }
    } else {
      this.sendLiveDraftStartEnd('wsn_live_draft_end');
      this.initialLoadComplete = false;
      if (groupORUserData?.message_id) {
        // clicked from the search results will need to use a logic to go to the text
        this.selectedChatConversation = {};
      }
      this.rows = Math.max(
        groupORUserData?.unread_count || this.pageSize,
        this.pageSize,
      );
      groupORUserData.unread_count = 0;

      this.getConversationMessagesList(groupORUserData);
      this.unreadArchivedConversationCount = this.conversationListData?.filter(
        (conv: any) => conv?.archived_id && conv?.unread_count > 0,
      )?.length;
    }
  }
  updateGroupMemberInfo(memberIds: any) {
    if (memberIds?.length) {
      const otherMembers = this.conversationListData?.filter((user: any) =>
        memberIds?.includes(user?.id),
      );
      this.selectedChatConversation['members'] = [
        ...otherMembers?.map((user: any) => user?.user_name),
      ];
      this.selectedChatConversation['memberIds'] = memberIds;
      this.selectedChatConversation['otherMemberIds'] = memberIds?.filter(
        (id: any) => id != this.subscriberUserId,
      );
      this.selectedChatConversation?.otherMemberIds.forEach(
        (id: any, index: any) => {
          let color = this.generateColorFromUUID(id);

          this.groupMemberColorAssign[id] = color;
        },
      );
    }
  }
  checkAndSetChatWindowHeight() {
    const chatWindowContainer = document.getElementById(
      'chat-window-container',
    );
    if (chatWindowContainer) {
      this.containerHeight = `${
        Math.max(document.documentElement.clientHeight, window.innerHeight) -
        Math.ceil(
          Math.max(
            this.largeView ? 70 : 60,
            chatWindowContainer.getBoundingClientRect().top,
          ) / 10,
        ) *
          10
      }px`;
    } else {
      setTimeout(() => {
        this.checkAndSetChatWindowHeight();
      }, 250);
    }
  }
  getConversationMessagesList(groupORUserData: any) {
    this.checkAndSetChatWindowHeight();

    if (this.selectedChatConversation?.id == groupORUserData?.id) return;
    this.selectedChatConversation = groupORUserData;
    this.spinnerService.show('Loading Chat History');

    let _Id: any = groupORUserData?.id;

    let params: any = { counter_part_id: _Id };

    if (this.selectedChatConversation?.chat_type == 'group_chat') {
      params.group_message = 1;
      _Id += ':group';
    }
    this.router.navigate(['/message'], { fragment: _Id });

    if (this.rows) {
      params['rows'] = this.rows;
    }

    if (groupORUserData?.message_id) {
      params['message_id'] = groupORUserData?.message_id;
    }

    this.messageService
      .getConversationMessages(params)
      .subscribe((response: any) => {
        if (response?.status == 'success') {
          this.chatFirstLastIds = response?.chat_info;
          if (groupORUserData?.message_id) {
            this.formatMessageListFromSearchClick(
              response?.data,
              groupORUserData?.message_id,
            );
          } else {
            this.formatInitialLoadMessageList(response?.data);
          }

          if (response?.selected_conversation_detail?.id) {
            this.selectedChatConversation = {
              ...this.selectedChatConversation,
              ...response?.selected_conversation_detail,
            };

            this.updateGroupMemberInfo(
              response?.selected_conversation_detail?.member_user_ids,
            );
          }
        } else {
          this.goBack();
          this.toasterService.setMessage({
            successMessage: '',
            errorMessage: response['message'],
          });
        }
      });
  }
  resetChanges(delayTime: number = 500) {
    this.chatMessage = '';
    this.handOverLogData = null;
    this.selectedMessage = null;
    this.selectedJob = null;
    this.sendBtnPressed = false;
    setTimeout(() => {
      this.scrollToBottom();
      this.spinnerService.hide();
    }, delayTime);
  }
  highlightSelectedMessageFromChat(selectedMessageId: any) {
    setTimeout(() => {
      const selectedMessageElement: any = document.getElementById(
        `chat-${selectedMessageId}`,
      );

      if (selectedMessageElement) {
        selectedMessageElement.scrollIntoView({
          behavior: 'smooth',
          block: 'end',
          inline: 'nearest',
        });

        selectedMessageElement.classList.add('fw-bold');
      }
      this.spinnerService.hide();
    }, 300);
  }

  formatMessageListFromSearchClick(messageData: any, selectedMessageId: any) {
    this.messageList = messageData;
    this.markMessagesRead();

    this.chatMessage = '';
    this.handOverLogData = null;
    this.selectedMessage = null;
    this.selectedJob = null;
    this.sendBtnPressed = false;

    setTimeout(() => {
      this.initialLoadComplete = true;
    }, 1000);
    this.highlightSelectedMessageFromChat(selectedMessageId);
  }

  formatInitialLoadMessageList(messageData: any) {
    // this should only be called for inital loading
    this.messageList = messageData?.reverse();

    const cursorId = this.messageList[0]?.id;
    this.markMessagesRead();
    this.resetChanges();

    if (
      this.messageList[0]?.id != this.chatFirstLastIds?.first_id &&
      this.selectedChatConversation?.id &&
      cursorId
    ) {
      const container = this.content.nativeElement;
      const previousScrollHeight = container.scrollHeight;
      const previousScrollTop = container.scrollTop;

      setTimeout(() => {
        this.rows = Math.max(this.rows, 25);
        let params: any = {
          counter_part_id: this.selectedChatConversation?.id,
          cursor_id: cursorId,
        };
        if (this.selectedChatConversation?.chat_type == 'group_chat') {
          params.group_message = 1;
        }

        if (this.rows) {
          params['rows'] = this.rows;
        }

        this.messageService
          .getConversationMessages(params)
          .subscribe((response: any) => {
            if (response?.status == 'success') {
              this.messageList = [
                ...response?.data?.reverse(),
                ...this.messageList,
              ];
              this.chatFirstLastIds = response?.chat_info;
              this.cdr.detectChanges();

              requestAnimationFrame(() => {
                const newScrollHeight = container.scrollHeight;

                container.scrollTop =
                  newScrollHeight - previousScrollHeight + previousScrollTop;
              });
            }
          });
      }, 500);
    }
    setTimeout(() => {
      this.initialLoadComplete = true;
      this.backupMessagesToIndexDb(
        this.selectedChatConversation,
        this.messageList,
      );
    }, 1000);
  }
  openCamPopupDialog() {
    const dialogRef = this.dialogService.open(FileUploadComponent, {
      data: { showFrom: 'chat' },
    });
    dialogRef.afterClosed().subscribe((value: any) => {
      if (value && value !== 'error') {
        this.sendMessage(value);
      }
    });
  }
  formatSendMessageApiResponse(response: any) {
    const responseData = response?.data;

    if (
      (responseData?.group_id || responseData?.receiver?.id) !=
      this.selectedChatConversation?.id
    )
      return;

    if (response?.chat_info) {
      this.chatFirstLastIds = response?.chat_info;
    }

    const index = this.messageList?.findIndex(
      (item: any) => item?._id == responseData?._id,
    );

    if (index !== -1) {
      this.messageList[index] = responseData;
      this.cdr.detectChanges();
    } else {
      const insertIndex = this.messageList?.findIndex(
        (item: any) => item?.id > responseData?.id,
      );

      if (insertIndex === -1) {
        this.messageList.push(responseData);
      } else {
        this.messageList?.splice(insertIndex, 0, responseData);
      }
      this.resetChanges();
      this.updateChatFirstLastIds();
    }

    if (this.selectedChatConversation?.archived_id) {
      this.getGroupORUserMessageList();
    } else {
      const index = this.conversationListData?.findIndex(
        (item: any) =>
          item?.id == (responseData?.group_id || responseData?.receiver?.id),
      );
      if (index !== -1) {
        this.conversationListData[index] = {
          ...this.conversationListData[index],
          last_message: this.getLastMessageInfo(responseData),
          sent_at: responseData?.created_at,
          sent_by: 'You',
        };
        this.sortUserList();
      }
    }
  }
  getLastMessageInfo(data: any) {
    if (data?.message) return data?.message;
    if (!data?.file) return '';
    if (['.mp3'].includes(data?.file_extension)) return 'Voice Message';
    if (['.mp4', '.mov', '.webm', '.mkv'].includes(data?.file_extension))
      return 'Video Message';
    return 'Photo';
  }

  sendMessage(value?: any) {
    this.sendBtnPressed = true;
    setTimeout(() => {
      this.sendBtnPressed = false;
    }, 3000);
    const message = this.chatMessage;

    this.chatMessage = '';
    this.sendLiveDraftStartEnd('wsn_live_draft_end');
    this.onMessageInput(true);
    const inputField: any = document.getElementById(
      'chatInputField',
    ) as HTMLElement;
    if (inputField) {
      inputField?.focus();
      inputField?.click();
      setTimeout(() => {
        inputField?.focus();
        inputField?.click();
      }, 150);
    }

    const [fileData, messageBody, params] = this.getFormattedFileData(
      value,
      message,
    );
    fileData.append('messageBody', JSON.stringify(messageBody));
    this.appService
      .formDataApi('gt_message/send_message', fileData, false, params)
      .then((response: any) => {
        this.getAndFormatCachedMessages();

        if (response?.data?.id) {
          this.formatSendMessageApiResponse(response);
        }
      });
  }
  getFormattedFileData(value: any, message: any) {
    let fileData: FormData = new FormData();
    const uuid = uuidv4();
    let messageBody: any = {
      message: message,
      created_at: new Date(),
      _id: uuid,
      id: (this.chatFirstLastIds?.last_id || 0) + 1,
      sender: { id: this.subscriberUserId },
      read_json: {},
      receiver: {
        id: this.selectedChatConversation?.id,
        user_name: this.selectedChatConversation?.user_name,
      },
    };
    fileData.append('message', message);

    let params: any = {};

    if (value?.actualFileUpload?.type?.startsWith('video/')) {
      params['video_upload'] = 1;
    }

    if (value?.actualFileUpload) {
      // this.spinnerService.show('Uploading File');
      fileData.append('file', value.actualFileUpload);
      messageBody['file_extension'] = value?.file_extension;
      if (value?.newComment) {
        fileData.append('message', value?.newComment);
        messageBody['message'] = value?.newComment;
      }
    }

    fileData.append('_id', uuid);
    fileData.append('counter_part_id', this.selectedChatConversation?.id);

    fileData.append('image_source', value?.uploadType);
    if (this.selectedMessage?.id) {
      fileData.append('message_id', this.selectedMessage?.id);
      messageBody['reply'] = this.selectedMessage;
    }

    if (this.selectedJob?.event_id) {
      if (this.selectedJob?.job_id) {
        fileData.append('job_id', this.selectedJob?.event_id);
        messageBody['job'] = {
          site_name: this.selectedJob?.site_name,
          job_id: this.selectedJob?.job_id,
          id: this.selectedJob?.event_id,
        };
      } else {
        fileData.append('patrol_route_id', this.selectedJob?.event_id);
        messageBody['patrol_route'] = {
          site_name: this.selectedJob?.site_name,
          id: this.selectedJob?.event_id,
        };
      }
    }
    if (this.selectedChatConversation?.chat_type == 'group_chat') {
      fileData.append('group_message', '1');
      messageBody['group_id'] = this.selectedChatConversation?.id;
    }
    if (this.selectedChatConversation?.archived_id) {
      fileData.append(
        'un_archive_chat',
        this.selectedChatConversation?.archived_id,
      );
    }

    return [fileData, messageBody, params];
  }

  goBack() {
    // this.getGroupORUserMessageList();
    this.backupMessagesToIndexDb(
      this.selectedChatConversation,
      this.messageList,
    );

    this.messageList = [];
    this.selectedChatConversation = null;
    this.router.navigate(['/message']);
  }
  onOpenImage(event: any, data: any) {
    var target = event.target || event.srcElement || event.currentTarget;
    var srcAttr = target.attributes.src;

    this.dialogService.open(MediaPreviewComponent, {
      data: { mediaSrc: srcAttr.nodeValue, timeStamp: data.updated_at },
    });
  }
  showHideFAB() {
    this.showFabActions = !this.showFabActions;
  }
  openJobSearchTemplate(template: any) {
    this.dialogService.open(
      template,
      {
        data: {},
      },
      this.viewContainerRef,
    );
  }
  searchJobs(event: any) {
    this.jobFilterValue = event.target.value;
    if (event.target?.value?.length > 3) {
      let body: any = {
        event_type: 'filter_user_jobs',
        search_str: event.target?.value,
      };
      this.userService.getUserUpdateLog(body).subscribe((response: any) => {
        if (response['status'] == 'success') {
          this.filteredJobList = response?.data;
        } else {
          this.toasterService.setMessage({
            successMessage: '',
            errorMessage: response['message'],
          });
        }
      });
    } else {
      this.filteredJobList = [];
    }
  }
  routeToJob(messageData: any) {
    if (messageData?.job?.id) {
      this.router.navigate([`/job-detail/JOBID`], {
        queryParams: { jId: messageData?.job?.id },
      });
    } else {
      this.router.navigate([
        '/view-route',
        {
          rKey: String(messageData?.patrol_route?.id),
        },
      ]);
    }
  }
  getAnchorHeight() {
    try {
      const anchor = this.anchorList?.first?.nativeElement;
      return anchor?.offsetTop;
    } catch (error) {
      return 0;
    }
  }

  onWindowScroll(event: any): void {
    this.showChatOptions = false;
    if (this.offlineMode) return;
    if (this.isLastItemVisible()) {
      this.websocketMessageReceivedCount = 0;
    }

    // this.closeOpenedItemsOutsideClick();
    // Early return if conditions aren't met
    if (!(
      (this.messageList[0]?.id !== this.chatFirstLastIds?.first_id ||
        this.messageList[this.messageList?.length - 1]?.id !==
          this.chatFirstLastIds?.last_id) &&
      this.selectedChatConversation?.id &&
      this.initialLoadComplete
    ))
      return;

    const isAtBottom =
      event.target.scrollHeight -
        event.target.scrollTop -
        event.target.clientHeight <=
      15;
    const isAtTop = event.target.scrollTop === 0;

    // Handle top and bottom scrolling logic separately
    if (
      isAtTop &&
      this.messageList[0]?.id !== this.chatFirstLastIds?.first_id
    ) {
      this.loadMessages('top', event);
    } else if (
      isAtBottom &&
      this.messageList[this.messageList?.length - 1]?.id !==
        this.chatFirstLastIds?.last_id
    ) {
      this.loadMessages('bottom', event);
    }
  }

  loadMessages(position: 'top' | 'bottom', event: any): void {
    const cursorId =
      position === 'top'
        ? this.messageList[0]?.id
        : this.messageList[this.messageList?.length - 1]?.id;

    const params: any = {
      counter_part_id: this.selectedChatConversation?.id,
      cursor_id: cursorId,
      rows: this.rows || 15,
      sort_asc: position === 'bottom' ? 1 : 0,
    };

    if (this.selectedChatConversation?.chat_type === 'group_chat') {
      params.group_message = 1;
    }

    // Set timeout debounce to avoid rapid API calls
    clearTimeout(this.scrollTimeout);
    this.scrollTimeout = null;
    this.scrollTimeout = setTimeout(() => {
      const anchorTopBefore = this.getAnchorHeight();

      this.messageService
        .getConversationMessages(params)
        .subscribe((response: any) => {
          if (response?.status === 'success') {
            const scrollContainer = event.target;

            if (position === 'top') {
              this.messageList = [
                ...response?.data?.reverse(),
                ...this.messageList,
              ];
            } else {
              this.messageList = [...this.messageList, ...response?.data];
            }

            this.chatFirstLastIds = response?.chat_info;
            this.anchorIndex += response?.data?.length;

            setTimeout(() => {
              // Handle scroll adjustment for iphone brwsers
              if (position === 'top') {
                const anchorTopAfter = this.getAnchorHeight();

                scrollContainer.scrollTop += anchorTopAfter - anchorTopBefore;
              }
            }, 10);
          }
          clearTimeout(this.scrollTimeout);
          this.scrollTimeout = null;
        });
    }, 300);
  }

  manageMessage(action: string, msgData: any) {
    let params: any = {};
    let body: any = {};

    switch (action) {
      case 'editComment':
        params.edit_message = 1;
        body.message = msgData?.message;
        break;
      case 'deleteMessage':
        params.delete_message = 1;
        params.counter_part_id = this.selectedChatConversation?.id;
        params.group_message =
          this.selectedChatConversation?.chat_type === 'group_chat' ? 1 : 0;
        break;
      case 'forwardMessage':
        params.forward_message = 1;
        body.user_ids = [
          ...new Set(
            this.selectedForwardMessageUsers?.map((user: any) => user?.id),
          ),
        ];
        break;
    }

    this.messageService
      .manageMessage(msgData?.id, body, params)
      .subscribe((response: any) => {
        if (response?.status == 'success') {
          switch (action) {
            case 'editComment':
              const editedMessage = response?.data;
              const index = this.messageList?.findIndex(
                (item: any) => item?.id === editedMessage?.id,
              );
              if (index !== -1) this.messageList[index] = { ...editedMessage };

              break;
            case 'deleteMessage':
              this.messageList = this.messageList?.filter(
                (msg: any) => msg?.id != msgData?.id,
              );
              this.chatFirstLastIds = response?.chat_info;

              break;
            case 'forwardMessage':
              this.getGroupORUserMessageList();
          }
          this.spinnerService.hide();
        } else {
          this.spinnerService.hide();
          this.toasterService.setMessage({
            successMessage: '',
            errorMessage: response['message'],
          });
        }
      });
  }
  clearAndFocusTextBox(elementId: string) {
    setTimeout(() => {
      var element = <HTMLInputElement>document.getElementById(elementId);
      element?.focus();
    }, 100);
  }
  deleteChatMessage(msgData: any) {
    const dialogRef = this.dialogService.open(ConfirmDialogComponent, {
      data: {
        title: 'Are you sure?',
        message: 'THIS ACTION CANNOT BE UNDONE!',
        btn2Detail: { text: 'Delete', class: 'btn-danger' },
      },
    });
    dialogRef.afterClosed().subscribe((dialogResponse) => {
      if (dialogResponse === true) {
        this.spinnerService.show();
        this.manageMessage('deleteMessage', msgData);
      }
    });
  }
  selectDelselectAssignee(event: any, assignee: any) {
    assignee.selected = event.target.checked;
    this.selectedForwardMessageUsers = this.forwardMessageUserListData?.filter(
      (user: any) => user?.selected,
    );
  }

  copyMessageToClipBoard(messageData: any) {
    this.toasterService.copyContentToClipBoard(messageData?.message);
  }
  sendLiveDraftStartEnd(
    event:
      'wsn_live_draft_start' | 'wsn_live_draft_end' = 'wsn_live_draft_start',
  ) {
    if (event == 'wsn_live_draft_end') {
      if (!this.liveDraftInfoSend) return;
      this.liveDraftInfoSend = false;
    } else {
      if (this.liveDraftInfoSend) return;
      this.liveDraftInfoSend = true;
    }
    if (!this.selectedChatConversation?.id) return;

    this.webSocketService.sendData({
      event: event,
      conversation_id:
        this.selectedChatConversation?.chat_type == 'individual_chat'
          ? this.subscriberUserId
          : this.selectedChatConversation?.id,
      chat_type: this.selectedChatConversation?.chat_type,
      receiver_id: this.selectedChatConversation?.id,
      sender_id: this.subscriberUserId,
    });
  }
  onMessageInput(clear = false) {
    const maxHeight = 150;
    const textarea = document.getElementById(
      'chatInputField',
    ) as HTMLTextAreaElement;
    if (clear) {
      textarea.value = '';
    } else {
      this.sendLiveDraftStartEnd('wsn_live_draft_start');
    }

    textarea.style.height = 'auto';

    const newHeight = Math.max(34, Math.min(textarea.scrollHeight, maxHeight));

    textarea.style.height = `${newHeight}px`;
    textarea.style.overflowY =
      textarea.scrollHeight > maxHeight ? 'auto' : 'hidden';
    textarea.style.fontSize = '0.9rem';

    if (this.liveDraftingTimeOutFn) clearTimeout(this.liveDraftingTimeOutFn);
    this.liveDraftingTimeOutFn = setTimeout(() => {
      this.sendLiveDraftStartEnd('wsn_live_draft_end');
    }, 1000 * 10);
  }

  addRemoveGroupMembers(event: any, assignee: any) {
    const checked = event.target.checked;
    assignee.selected = checked;
    if (!assignee?.selected) {
      assignee.additional_info = {};
    }

    const selectedMembers = this.assigneeList?.filter(
      (user: any) => user?.selected,
    );
    this.selectedGroupMembers = selectedMembers?.map((user: any) => {
      return {
        id: user?.id,
        additional_info: user?.additional_info,
      };
    });
  }
  groupMemeberPrivilages(event: any, assignee: any, field: string) {
    const checked = event.target.checked;

    assignee.additional_info = assignee?.additional_info || {};
    assignee['additional_info'][field] = checked;
    const selectedMembers = this.assigneeList?.filter(
      (user: any) => user?.selected,
    );
    this.selectedGroupMembers = selectedMembers?.map((user: any) => {
      return {
        id: user?.id,
        additional_info: user?.additional_info,
      };
    });
  }
  manageChatGroup(action: string, groupData: any) {
    let params: any = {};
    let body: any = {};
    switch (action) {
      case 'deleteGroup':
        params.delete_group = 1;
        body.message_group_id = groupData?.id;
        break;
      case 'updateGroup':
        body.message_group_id = groupData?.id;
        body.group_name = groupData?.group_name;
        body.group_members = this.selectedGroupMembers;
        break;
      case 'createGroup':
        body.group_name = groupData?.group_name;
        body.group_members = this.selectedGroupMembers;
        break;
    }

    this.spinnerService.show();
    this.messageService
      .manageMessageGroup(body, params)
      .subscribe((response: any) => {
        if (response?.status == 'success') {
          switch (action) {
            case 'deleteGroup':
              this.dialogRef?.close();
              if (groupData?.id === this.selectedChatConversation?.id)
                this.selectedChatConversation = {};
              this.getGroupORUserMessageList();
              break;
            case 'updateGroup':
              this.selectedGroupDetails = {};
              this.assigneeList = JSON.parse(
                JSON.stringify(
                  this.conversationListData?.filter(
                    (user: any) => user?.chat_type == 'individual_chat',
                  ),
                ),
              );
              this.formatGroupInfo(groupData?.id);
              this.getGroupORUserMessageList();
              break;
            case 'createGroup':
              this.dialogRef?.close();
              this.openNewlyAddedGroup = true;
              this.getGroupORUserMessageList();
              break;
          }
          this.spinnerService.hide();
          this.selectedGroupMembers = [];
        } else {
          this.spinnerService.hide();
          this.toasterService.setMessage({
            successMessage: '',
            errorMessage: response['message'],
          });
        }
      });
  }
  deleteMessageGroup(grpData: any) {
    const dialogRef = this.dialogService.open(ConfirmDialogComponent, {
      data: {
        title: 'Are you sure?',
        message: 'THIS ACTION CANNOT BE UNDONE!',
        btn2Detail: { text: 'Delete', class: 'btn-danger' },
      },
    });
    dialogRef.afterClosed().subscribe((dialogResponse) => {
      if (dialogResponse === true) {
        this.spinnerService.show();
        this.manageChatGroup('deleteGroup', grpData);
      }
    });
  }
  sortUserList() {
    this.conversationListData = this.conversationListData?.sort(
      (a: any, b: any) =>
        new Date(b?.sent_at).getTime() - new Date(a?.sent_at).getTime(),
    );
    this.unreadArchivedConversationCount = this.conversationListData?.filter(
      (conv: any) => conv?.archived_id && conv?.unread_count > 0,
    )?.length;

    if (this.openNewlyAddedGroup) {
      this.openNewlyAddedGroup = false;
      if (this.conversationListData?.length) {
        const newlyAddedGroup = this.conversationListData[0];
        this.resetPagesAndGetData(newlyAddedGroup);
      }
    }

    this.conversationDetailedDataDict = {};
    this.userConvDetailedDataDict = {};

    this.conversationListData?.forEach((item: any) => {
      this.conversationDetailedDataDict[item?.unique_conversation_id] = item;
      this.userConvDetailedDataDict[item?.id] = item;
    });
  }
  searchChats() {
    if (this.chatFilterValue?.length > 2) {
      this.messageService
        .getConversationMessages({
          search_chat: 1,
          search_str: this.chatFilterValue,
          rows: this.largeView ? 15 : 10,
        })
        .subscribe((response: any) => {
          if (response?.status == 'success') {
            this.filteredChatListData = [];
            this.chatSearchLookup = false;
            response?.data?.forEach((result: any) => {
              const chatInfo =
                this.conversationDetailedDataDict?.[
                  result?.unique_conversation_id
                ];

              this.filteredChatListData.push({ ...chatInfo, ...result });
            });
          } else {
            this.chatSearchLookup = false;
            this.toasterService.setMessage({
              successMessage: '',
              errorMessage: response['message'],
            });
          }
        });
    } else {
      this.chatSearchLookup = false;
    }
  }
  onChatSearchLookup() {
    if (this.offlineMode) {
      this.filteredChatListData = [];
      const filteredChatListData = this.messagesListForOfflineSearch?.filter(
        (msg: any) =>
          msg?.message
            ?.toLowerCase()
            ?.includes(this.chatFilterValue?.toLowerCase()),
      );

      this.chatSearchLookup = false;
      filteredChatListData?.forEach((result: any) => {
        const chatInfo =
          this.conversationDetailedDataDict?.[result?.unique_conversation_id];

        this.filteredChatListData.push({ ...chatInfo, ...result });
      });
    } else {
      this.chatSearchLookup = true;
      if (this.onChatSearchLookupTimeOutFn)
        clearTimeout(this.onChatSearchLookupTimeOutFn);

      if ([5, 10, 15, 20, 25, 30, 35].includes(this.chatFilterValue?.length)) {
        this.searchChats();
      } else {
        this.onChatSearchLookupTimeOutFn = setTimeout(() => {
          this.searchChats();
        }, 1000);
      }
    }
  }

  async getGroupDetails(grpId: any) {
    return new Promise((resolve) => {
      this.spinnerService.show('Fetching Data');
      this.messageService
        .manageMessageGroup({ message_group_id: grpId }, { get_details: 1 })
        .subscribe((response: any) => {
          if (response?.status == 'success') {
            resolve(response?.data);
            this.spinnerService.hide();
          } else {
            this.spinnerService.hide();
            this.toasterService.setMessage({
              successMessage: '',
              errorMessage: response['message'],
            });
            resolve({});
          }
        });
    });
  }
  generateColorFromUUID(uuid: string) {
    const hex = uuid.replace(/-/g, '').toLowerCase();
    const int32 = parseInt(hex.slice(0, 8), 16);
    const hue = int32 % 360;

    const lightColor = `hsl(${hue}, 65%, 80%)`;
    const darkColor = `hsl(${hue}, 40%, 25%)`;

    return {
      'border-color': lightColor,
      'color': lightColor,
      'background': darkColor,
    };
  }
  manageConversation(action: string) {
    let title: string = '';
    switch (action) {
      case 'archive':
        title = `Are you sure to archive this chat?`;
        break;
      case 'unarchive':
        title = `Are you sure to remove this chat from archives?`;
        break;
      case 'clear':
        title = `Are you sure to clear this chat?`;
        break;
    }
    const dialogRef = this.dialogService.open(ConfirmDialogComponent, {
      data: {
        title: title,
      },
    });
    dialogRef.afterClosed().subscribe((dialogResponse) => {
      if (dialogResponse === true) {
        let body: any = {};
        let params: any = {};
        switch (action) {
          case 'archive':
            params.archive_chat = 1;

            body[
              this.selectedChatConversation?.chat_type == 'group_chat'
                ? 'group_id'
                : 'counter_part_id'
            ] = this.selectedChatConversation?.id;
            break;
          case 'unarchive':
            params.un_archive_chat = 1;
            body.archived_id = this.selectedChatConversation?.archived_id;
            break;
          case 'clear':
            params.clear_chat = 1;
            body[
              this.selectedChatConversation?.chat_type == 'group_chat'
                ? 'group_id'
                : 'counter_part_id'
            ] = this.selectedChatConversation?.id;
            break;
        }

        this.spinnerService.show();
        this.messageService
          .manageMessageConversation(body, params)
          .subscribe((response: any) => {
            if (response?.status == 'success') {
              switch (action) {
                case 'archive':
                  this.getGroupORUserMessageList();
                  break;
                case 'unarchive':
                  this.getGroupORUserMessageList();
                  break;
                case 'clear':
                  this.getGroupORUserMessageList();
                  const selectedChat = this.selectedChatConversation;
                  this.selectedChatConversation = null;
                  this.resetPagesAndGetData(selectedChat);
                  break;
              }

              this.spinnerService.hide();
              this.selectedGroupMembers = [];
            } else {
              this.spinnerService.hide();
              this.toasterService.setMessage({
                successMessage: '',
                errorMessage: response['message'],
              });
            }
          });
      }
    });
  }
  updateChatFirstLastIds() {
    if (this.messageList?.length) {
      const firstId = this.messageList[0]?.id;
      const lastId = this.messageList[this.messageList?.length - 1]?.id;

      if (
        !this.chatFirstLastIds?.first_id ||
        firstId < this.chatFirstLastIds?.first_id
      )
        this.chatFirstLastIds.first_id = firstId;
      if (
        !this.chatFirstLastIds?.last_id ||
        lastId > this.chatFirstLastIds?.last_id
      )
        this.chatFirstLastIds.last_id = lastId;
    } else {
      this.chatFirstLastIds = {};
    }
  }

  async backupMessagesToIndexDb(selectedConversation: any, messageList: any) {
    if (!selectedConversation?.id) return;

    const selectedChatConversation = this.conversationListData?.find(
      (conv: any) => conv?.id == selectedConversation?.id,
    );

    const messageCount: number = 20;
    const indexKey = `subscriberData-${this.subscriberUserId}`;

    const subscriberData = (await gTDB.userData.get(indexKey)) || {};

    const savedChatData = subscriberData?.savedChatData || {};

    let currentChatData = JSON.parse(
      savedChatData?.[selectedChatConversation?.id] || '{}',
    );
    currentChatData.chatDetails = selectedChatConversation;
    const userChatMessages = messageList?.slice(-messageCount);
    currentChatData.chatListData = userChatMessages;

    savedChatData[selectedChatConversation?.id] =
      JSON.stringify(currentChatData);

    subscriberData['savedChatData'] = savedChatData;

    await gTDB.userData.delete(indexKey);
    await gTDB.userData.add(subscriberData, indexKey);
  }
  async getMessagesAndInfoFromIndexDb(chatDetail: any) {
    const indexKey = `subscriberData-${this.subscriberUserId}`;
    const subscriberData = (await gTDB.userData.get(indexKey)) || {};
    const savedChatData = subscriberData?.savedChatData || {};
    this.messagesListForOfflineSearch = [];
    this.conversationListData = Object.values(savedChatData)
      ?.map((conv: any) => {
        const parsedConv = JSON.parse(conv || '{}');

        if (chatDetail?.id === parsedConv?.chatDetails?.id) {
          this.selectedChatConversation = parsedConv?.chatDetails;
          this.messageList = parsedConv?.chatListData;
        }
        const chatDetails = {
          ...parsedConv?.chatDetails,
          chatListData: parsedConv?.chatListData,
        };

        const messageList: any = parsedConv?.chatListData?.map((msg: any) => {
          return {
            message_id: msg?.id,
            id: parsedConv?.chatDetails?.id,
            message: msg?.message,
            unique_conversation_id:
              parsedConv?.chatDetails?.unique_conversation_id,
          };
        });
        this.messagesListForOfflineSearch = [
          ...this.messagesListForOfflineSearch,
          ...messageList,
        ];
        return chatDetails;
      })
      .filter((conv: any) => conv?.id);

    this.sortUserList();
  }
  onProfileImageClick(fileUrl: any) {
    if (!fileUrl) return;
    this.dialogService.open(
      MediaPreviewComponent,
      {
        data: { mediaSrc: fileUrl },
      },
      this.viewContainerRef,
    );
  }
  updateUserPostion() {
    // call this api to check if the user is on the message component so that backend can send push notification
    this.messageService
      .getConversationMessages({
        update_subscriber_user_position: 1,
        is_on_messages: 0,
      })
      .subscribe((response: any) => {});
  }
  async getAllIndexedDbItems() {
    try {
      const data = await gTDB.gtSavedData.toArray();

      return data;
    } catch (error) {
      return [];
    }
  }
  checkMessagesNotInServer() {
    const itemsNotInServer = this.messageList?.some(
      (msg: any) => msg?.cachedItem,
    );
    if (itemsNotInServer) {
    }
  }
  async getAndFormatCachedMessages() {
    const indexedDbListData: any = await this.getAllIndexedDbItems();

    const currentMessageListIndexDbIds = [
      ...new Set(
        this.messageList
          ?.map((item: any) => item?.indexDBId)
          ?.filter((item: any) => item),
      ),
    ];

    indexedDbListData?.forEach((cachedItem: any) => {
      if (
        cachedItem?.pathName === '/api/gt_message/send_message/' &&
        cachedItem?.counter_part_id === this.selectedChatConversation?.id &&
        cachedItem?.messageBody &&
        !currentMessageListIndexDbIds?.includes(cachedItem?.indexDBId)
      ) {
        const messageBody: any = JSON.parse(cachedItem?.messageBody);
        const index = this.messageList?.findIndex(
          (item: any) => item?._id == messageBody?._id,
        );

        if (index !== -1) {
          this.messageList[index] = {
            ...this.messageList[index],
            ...cachedItem,
            indexDBId: cachedItem?.indexDBId,
            cachedItem: true,
          };

          this.cdr.detectChanges();
          this.updateChatFirstLastIds();
        } else {
          if (cachedItem?.file) {
            const fileUrl = URL.createObjectURL(cachedItem?.file);
            messageBody['file'] = fileUrl;
          }
          messageBody['indexDBId'] = cachedItem?.indexDBId;
          messageBody['cachedItem'] = true;

          this.messageList?.push(messageBody);
          this.cdr.detectChanges();
          this.updateChatFirstLastIds();
        }
      }
    });
    this.resetChanges();
  }

  audioBtnPressed(event: any) {
    // https://app.shortcut.com/sendem/story/10819/add-vibration-to-certain-actions-to-improve-ux
    this.deviceInfoService.triggerCustomPulsePattern();
    const fileData: any = this.getFormattedFileData({}, '');
    this.pageService.miscSubjectParam.next({
      startAudio: true,
      fileData: fileData,
    });
    event.preventDefault();
  }
  getNotificationTotalCount() {
    this.profileService
      .getNotifications({ get_count: 1 })
      .subscribe((response: any) => {
        if (response['status'] == 'success') {
          this.gtNotificationCount = response?.total_count;
        } else {
          this.toasterService.setMessage({
            successMessage: '',
            errorMessage: response['message'],
          });
        }
      });
  }
  getNotifications(initial = false) {
    this.spinnerService.show();
    let params: any = { rows: 10 };
    if (this.gtNotificationCursor)
      params.next_cursor = this.gtNotificationCursor;

    this.profileService.getNotifications(params).subscribe((response: any) => {
      if (response['status'] == 'success') {
        this.gtNotificationsList = [
          ...response?.data?.reverse(),
          ...this.gtNotificationsList,
        ];
        if (initial) {
          this.scrollToBottom();
        } else {
          const container = this.content.nativeElement;
          const previousScrollHeight = container.scrollHeight;
          const previousScrollTop = container.scrollTop;
          this.cdr.detectChanges();

          requestAnimationFrame(() => {
            const newScrollHeight = container.scrollHeight;

            container.scrollTop =
              newScrollHeight - previousScrollHeight + previousScrollTop;
          });
        }
        this.gtNotificationCursor = response?.next_cursor;
      } else {
        this.toasterService.setMessage({
          successMessage: '',
          errorMessage: response['message'],
        });
      }
      this.spinnerService.hide();
    });
  }
  onNotificationWindowScroll(event: any): void {
    // this.closeOpenedItemsOutsideClick();
    // Early return if conditions aren't met
    const isAtTop = event.target.scrollTop === 0;
    if (
      this.gtNotificationCount <= this.gtNotificationsList?.length ||
      !isAtTop ||
      !this.gtNotificationCursor
    )
      return;

    this.getNotifications();
  }
  redirectNotification(notification: any) {
    sessionStorage.removeItem('selectedTab');

    if (notification?.event_id) {
      if (['job'].includes(notification?.event_type)) {
        this.router.navigate([`/job-detail/JOBID`], {
          queryParams: { jId: notification?.event_id },
        });
      } else if (notification?.event_type === 'feedback') {
        this.router.navigate(['/support'], {
          queryParams: { sId: notification?.event_id },
        });
      } else if (notification?.event_type === 'incident') {
        this.router.navigate([
          '/view-incident',
          { inKey: String(notification?.event_id) },
        ]);
      } else if (notification?.event_type === 'user_license') {
        this.router.navigate(['/profile']);
      } else if (notification?.event_type === 'company_license') {
        this.router.navigate(['/company-profile']);
      } else if (notification?.event_type === 'patrol_job') {
        this.router.navigate([
          '/view-route',
          {
            rKey: String(notification?.event_id),
          },
        ]);
      } else if (notification?.event_type === 'run_sheet') {
        this.router.navigate([
          '/view-runsheet',
          {
            rKey: String(notification?.event_id),
          },
        ]);
      }
    } else {
      if (notification?.event_type === 'feedback') {
        this.router.navigate(['/support']);
      } else if (notification?.event_type === 'registration') {
        this.router.navigate(['/subscription']);
      } else if (notification?.event_type === 'hol_alert') {
        this.router.navigate(['/hand-over-log']);
      } else if (
        notification?.event_type === 'welfare_check' &&
        (this.isAdmin || this.isDispatchUser)
      ) {
        this.router.navigate(['/sos-welfare-alerts'], {
          fragment: 'welfareChecks',
        });
      }
    }
    this.deleteNotification(notification);
  }

  clearNotifications() {
    this.spinnerService.show();
    this.profileService
      .deleteNotifications({ clear_all: true }, {})
      .subscribe((response: any) => {
        if (response['status'] == 'success') {
          this.spinnerService.hide();
          this.gtNotificationsList = [];
          this.gtNotificationCount = 0;
        } else {
          this.spinnerService.hide();
          this.toasterService.setMessage({
            successMessage: '',
            errorMessage: response['message'],
          });
        }
      });
  }
  deleteNotification(notification: any) {
    this.profileService
      .deleteNotifications({}, { id_list: [notification.id] })
      .subscribe((response: any) => {
        if (response['status'] == 'success') {
          this.spinnerService.hide();
          this.gtNotificationsList = this.gtNotificationsList?.filter(
            (item: any) => !(item.id === notification.id),
          );
          if (!this.gtNotificationsList?.length) this.gtNotificationCount = 0;
        } else {
          this.spinnerService.hide();
          this.toasterService.setMessage({
            successMessage: '',
            errorMessage: response['message'],
          });
        }
      });
  }
}
